export const GET_ALL_DISPATCHER_CALL = "GET_ALL_DISPATCHER_CALL"
export const GET_ALL_DISPATCHER_CALL_BY_SEARCH = "GET_ALL_DISPATCHER_CALL_BY_SEARCH"
export const CREATE_DISPATCHER_CALL = "CREATE_DISPATCHER_CALL"
export const UPDATE_DISPATCHER_CALL = "UPDATE_DISPATCHER_CALL"
export const DELETE_DISPATCHER_CALL = "DELETE_DISPATCHER_CALL"
